import {RouteConfig} from "vue-router";
const LivemapView = () => import('../views/livemap/LivemapView.vue');

let livemap: RouteConfig[] = [
    {
        name: 'livemap',
        path: '/livemap',
        component: LivemapView,
    },
];

export default livemap;
